/** The two links a session can report: the Claude app on the Mac it runs on, and Remote Control. */
interface Openable {
  open_url?: string | null
  remote_url?: string | null
}

/**
 * The one link that opens an agent's session, or none. A `claude://` link opens
 * the session on the Mac it runs on, which a phone and a tablet cannot reach, so
 * where the device cannot hover only the claude.ai link of a session on Remote
 * Control is offered.
 */
export function openLink(agent: Openable | null | undefined, canHover: boolean): string | null {
  const remote = agent?.remote_url ?? null
  return canHover ? agent?.open_url ?? remote : remote
}

/**
 * What an https link needs so that following it leaves the app in a tab of its
 * own. A `claude://` link goes to the operating system, and a tab for it would
 * be left blank.
 */
export function newTabFor(link: string): { target?: '_blank'; rel?: string } {
  return link.startsWith('https:') ? { target: '_blank', rel: 'noopener noreferrer' } : {}
}
